import classNames from 'classnames'
import { GoogleMap } from 'legacy/lut/components/shared/googleMaps/GooglePoint'
import React from 'react'

import { calculateFileLink } from 'core/classes/helpers/saveFiles'

import BusinessHours from '../partnerPreview/BusinessHours'
import POSImages from '../partnerPreview/POSImages'
import styles from '../partnerPreviewMode/Sidebar.module.scss'

interface IProps {
  className?: string
  currentCompany: any
  logoItem: any
  noData: any
  images: any
  currentDay: any
  setCurrentDay: (arg0: any) => void
  handleCloseEdit: (isChanged: boolean, item: any) => void
}

export const Sidebar = ({
  className,
  currentCompany,
  logoItem,
  noData,
  images,
  setCurrentDay,
  handleCloseEdit,
  currentDay,
}: IProps) => {
  return (
    <aside className={classNames(styles.root, className || '')}>
      <div className={styles.banner}>
        {logoItem && (
          <img
            className={styles.banner__img}
            src={encodeURI(
              calculateFileLink({
                formId: 504,
                entryId: logoItem.EntryId,
                fieldName: 'Image',
                fileName: logoItem.Image,
                UID: logoItem.UID,
              })
            )}
            alt=""
          />
        )}
      </div>

      <GoogleMap
        className={styles.map}
        Lat={currentCompany.Lat}
        Lng={currentCompany.Lng}
        Label={currentCompany.CompanyLegalName}
        Address={currentCompany.AddressLine1}
        City={currentCompany.City}
      />

      <BusinessHours
        className={styles.workingHours}
        editable={false}
        currentDay={currentDay}
        setCurrentDay={setCurrentDay}
        currentCompany={currentCompany}
        noData={noData}
        handleCloseEdit={handleCloseEdit}
      />

      <POSImages className={styles.gallery} noData={noData} images={images} />
    </aside>
  )
}
